import { Lineup } from '../../../interfaces/lineup';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'lineup-details-general',
	templateUrl: './lineup-details-general.component.html',
	styleUrls: ['./lineup-details-general.component.scss']
})

export class LineupDetailsGeneralComponent implements OnInit {

	@Input() lineup: Lineup;
	@Input() form: NgForm;
	validEndpoint: boolean;
	hlsPullUrl = '';

	constructor() { }

	ngOnInit() { }
}
